import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { ExternalUrlGroupsListItem } from 'app/area/external-url-groups/list/types-store';
import { ExternalUrlGroupItemWire } from 'app/area/external-url-groups/list/types';

export const mapList = (listWire: ExternalUrlGroupItemWire[]): ExternalUrlGroupsListItem[] => {

  if ((listWire?.length ?? 0) === 0) {
    return [];
  }

  return listWire.map(item => ({
    id: item?.v,
    description: item?.d,
    ...(item?.disabled && { disabled: parseAsDateUTC(item?.disabled) })
  }));
};
